import script from "./UserDeletedChecker.vue?vue&type=script&lang=js"
export * from "./UserDeletedChecker.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__